import { FormRadioButtonGroup } from '@portal_components/components/FormRadioButtonGroup';
import { FormDropdown } from '@portal_components/components/FormDropdown';
import { useStandingData } from '../../hooks/useStandingData';
import { FormTextInput } from '@portal_components/components/FormTextInput';
import { FormDatePicker } from '@portal_components/components/FormDatePicker';
import { BulkAssignListForm } from '../../types';
import { FormCard } from '@portal_components/components/FormCard';

interface BulkAssignSiteDetailsTabProps {
  index: number;
}

export const BulkAssignSiteDetailsTab = ({ index }: BulkAssignSiteDetailsTabProps) => {
  const {
    isLoading,
    standingData: {
      standingDataSiteTypeList,
      standingDataAssetOwnershipList,
      standingDataNoCommsList,
      standingDataSiteStatusList,
      standingDataMeterWorkRequiredList
    }
  } = useStandingData();

  if (isLoading) {
    return <div className="flex flex-row justify-center">Loading standing data...</div>;
  }

  return (
    <FormCard columns={2}>
      <FormDatePicker<BulkAssignListForm>
        title="Effective Date"
        name={`siteList.${index}.effectiveDate`}
        mandatory
      />
      <FormDropdown<BulkAssignListForm>
        title="Site Status"
        name={`siteList.${index}.contractSiteStatusId`}
        placeholder="Select Site Status"
        elementsForDisplay={standingDataSiteStatusList}
        mandatory
        readonly
      />
      <FormTextInput<BulkAssignListForm>
        title="Site Reference Name"
        name={`siteList.${index}.siteReferenceName`}
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Import"
        name={`siteList.${index}.isImport`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' }
        ]}
        mandatory
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Export"
        name={`siteList.${index}.isExport`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' }
        ]}
        mandatory
      />
      <FormDropdown<BulkAssignListForm>
        title="Site Type"
        name={`siteList.${index}.siteTypeId`}
        placeholder="Select Site Type"
        elementsForDisplay={standingDataSiteTypeList}
      />
      <FormDropdown<BulkAssignListForm>
        title="Asset Ownership"
        name={`siteList.${index}.assetOwnership`}
        placeholder="Select Asset Ownership"
        elementsForDisplay={standingDataAssetOwnershipList}
      />
      <FormTextInput<BulkAssignListForm>
        title="Lease Purchase Term"
        name={`siteList.${index}.leasePurchaseTerm`}
      />
      <FormTextInput<BulkAssignListForm> title="Related MPRN" name={`siteList.${index}.relatedMprn`} />
      <FormTextInput<BulkAssignListForm> title="Batch Name" name={`siteList.${index}.batchName`} />
      <FormDropdown<BulkAssignListForm>
        title="Meter Work Required"
        name={`siteList.${index}.meterWorkRequired`}
        placeholder="Select Required Meter Work"
        elementsForDisplay={standingDataMeterWorkRequiredList}
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Multi Person Job"
        name={`siteList.${index}.multiPersonJob`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' }
        ]}
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Parking Available"
        name={`siteList.${index}.parkingAvailable`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' }
        ]}
      />
      <FormTextInput<BulkAssignListForm> title="Parking Notes" name={`siteList.${index}.parkingNotes`} />
      <FormTextInput<BulkAssignListForm>
        title="Meter Location Notes"
        name={`siteList.${index}.meterLocationNotes`}
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Mobile Signal"
        name={`siteList.${index}.mobileSignal`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' },
          { title: 'Unknown', value: 'U' }
        ]}
      />
      <FormDropdown<BulkAssignListForm>
        title="No Comms"
        name={`siteList.${index}.noCommsId`}
        placeholder="Select No Comms"
        elementsForDisplay={standingDataNoCommsList}
      />
      <FormRadioButtonGroup<BulkAssignListForm>
        title="Customer Owned Comms"
        name={`siteList.${index}.custOwnedComms`}
        buttons={[
          { title: 'Yes', value: 'Y' },
          { title: 'No', value: 'N' },
          { title: 'N/A', value: undefined }
        ]}
      />
      <FormTextInput<BulkAssignListForm> title="Utility ID" name={`siteList.${index}.utilityId`} readonly />
      <FormTextInput<BulkAssignListForm> title="Fuse Size" name={`siteList.${index}.fuseSize`} />
    </FormCard>
  );
};
